import { useHistory } from 'react-router-dom';
import styles from '../../../../styles/Home.module.css';
import {
  Container,
  Content,
  Title,
  DescriptionWrapper,
  DemonstratioWrapper,
  DemonstrationImage,
  BlueContainer,
  WhiteTitle,
  LogoContainer,
  LogoWrapper,
  LogoBB,
  LogoInfo,
  Message,
  TypesDescriptionRow,
  RowBreak,
  TypeItem,
  TypeImage,
  TypeDescription,
  StartButton,
  LogoSicredi,
} from "./Banner.styles";
import whitelabelService from '../../../../services/whitelabel/whitelabel.service';

export default function Banner() {
  const history = useHistory();
  const whitelabelCompany = whitelabelService
    .getWBDataCompany();

  const isSicredi = whitelabelCompany
    .workspace === 'vistoriasicredi';

  const goToForm = () => {
    localStorage.clear();
    history.push('inspection-type');
  }

  return (
    <>
      <Container id="banner">
        <Content src="" alt="Banner Infovist">
          <DescriptionWrapper>
            <Title>Vistoria digital <br />prática e rápida</Title>
            <Message>Mais comodidade e agilidade no<br />processo de vistoria {isSicredi ? 'por' : 'a partir de'} R$ {whitelabelCompany.price}.</Message>

            <TypesDescriptionRow>
              <TypeItem>
                <TypeImage src="images/header/quad-car.png" />
                <TypeDescription>Carros</TypeDescription>
              </TypeItem>

              <TypeItem>
                <TypeImage src="images/header/quad-motocycle.png" />
                <TypeDescription>Motos</TypeDescription>
              </TypeItem>

              <TypeItem>
                <TypeImage src="images/header/quad-truck.png" />
                <TypeDescription>Caminhões</TypeDescription>
              </TypeItem>

              <TypeItem>
                <TypeImage src="images/header/quad-semitrailer.png" />
                <TypeDescription>Semirreboques</TypeDescription>
              </TypeItem>

              <RowBreak />

              {whitelabelCompany.allowAgriculturalMachine && (
                <TypeItem>
                  <TypeImage src="images/header/quad-machine.png" />
                  <TypeDescription>Tratores</TypeDescription>
                </TypeItem>
              )}

              {whitelabelCompany.allowVessel && (
                <TypeItem>
                  <TypeImage src="images/header/quad-vessel.png" />
                  <TypeDescription>Embarcações</TypeDescription>
                </TypeItem>
              )}
            </TypesDescriptionRow>

            <StartButton onClick={() => { goToForm() }}>
              Iniciar vistoria agora!
            </StartButton>
          </DescriptionWrapper>
        </Content>
        <BlueContainer>
          <DemonstratioWrapper className={styles.hiddeOnMobile}>
            <DemonstrationImage
              src="images/banner-app-demonstration.png"
              alt="Demonstração do App"
            />
          </DemonstratioWrapper>
          <WhiteTitle>
            Essa é uma parceria entre o {whitelabelCompany.title} e a Infovist, desenvolvida para os cotistas de consórcio {whitelabelCompany.title}.
          </WhiteTitle>
          <LogoWrapper>
            {!isSicredi && (
              <LogoContainer>
                <LogoBB src={`images/header/${whitelabelCompany.logo}`} />
              </LogoContainer>
            )}
            {isSicredi && (
              <LogoContainer>
                <LogoSicredi src={`images/header/${whitelabelCompany.logo}`} />
              </LogoContainer>
            )}
            <LogoContainer>
              <LogoInfo src="images/header/infovist-logo.png" />
            </LogoContainer>
          </LogoWrapper>
        </BlueContainer>
      </Container>
    </>
  );
}